import React from 'react';
import { Field, Modal } from '../../components/ui';
import { fullName, VISIBILITIES } from '../../utils/helpers';
import { useFamilyMemberForm } from './useFamilyMemberForm';

// Mobile (APK) "add member to family": full-screen, single column, big toggle.
export default function FamilyMemberFormMobile(props) {
  const { head, onClose, isMarriage, sideOptions = ['Common'] } = props;
  const { mode, setMode, form, setF, existingGuestId, setExistingGuestId, available, saving, canSubmit, submit } = useFamilyMemberForm(props);

  return (
    <Modal
      fullScreen
      title={`Add to ${fullName(head)}'s family`}
      onClose={onClose}
      footer={<>
        <button className="btn light" type="button" onClick={onClose}>Cancel</button>
        <button className="btn primary" type="button" style={{ flex: 1, padding: 12 }} disabled={saving || !canSubmit} onClick={submit}>
          {saving ? 'Saving...' : 'Add to Family'}
        </button>
      </>}
    >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 14 }}>
        <button type="button" className={`btn ${mode === 'new' ? 'primary' : 'light'}`} style={{ padding: 12 }} onClick={() => setMode('new')}>New Guest</button>
        <button type="button" className={`btn ${mode === 'existing' ? 'primary' : 'light'}`} style={{ padding: 12 }}
          disabled={!available.length} onClick={() => setMode('existing')}>Pick Existing</button>
      </div>

      {mode === 'existing' ? (
        <Field label="Existing individual guest" type="select" value={existingGuestId} required
          options={available.map(row => ({ value: row.GuestId, label: `${fullName(row)} · ${row.MobileNumber || 'No phone'}` }))}
          onChange={setExistingGuestId} />
      ) : (
        <>
          <div className="muted" style={{ fontSize: 12, marginBottom: 12 }}>
            If this phone number already belongs to an individual guest, that guest moves into this family.
          </div>
          <Field label="Surname" value={form.Surname} onChange={v => setF('Surname', v)} />
          <Field label="Name" value={form.GuestName} required onChange={v => setF('GuestName', v)} />
          <Field label="Phone Number" value={form.MobileNumber} required onChange={v => setF('MobileNumber', v)} />
          {isMarriage && <Field label="Side" type="select" value={form.Side} options={sideOptions} onChange={v => setF('Side', v)} />}
          <Field label="Visibility" type="select" value={form.Visibility} options={VISIBILITIES} onChange={v => setF('Visibility', v)} />
          <Field label="Remarks" type="textarea" rows={2} value={form.Remarks} onChange={v => setF('Remarks', v)} />
        </>
      )}
    </Modal>
  );
}
